var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333374,
    width: 16,
    height: 16,
    rx: 4,
    fill: "#ED3241"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7_1042",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 4,
    width: 11,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1283 4.91753C13.4047 5.19939 13.4006 5.6523 13.1192 5.92913L7.16439 11.7865L3.54715 8.22844C3.26571 7.95161 3.26164 7.4987 3.53805 7.21684C3.81446 6.93497 4.26668 6.93089 4.54812 7.20772L7.16439 9.78118L12.1182 4.90841C12.3997 4.63158 12.8519 4.63566 13.1283 4.91753Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7_1042)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.33356,
    y: 3.00006,
    width: 9.99961,
    height: 9.99961,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.da8225e49c339c246c7a2ec322f40bcd.svg";
export { ForwardRef as ReactComponent };